// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fH","advertDetailService__price":"c-o_fJ"};